import { useRef, useEffect } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from 'react-query';
import { usePrint } from '../components/IdCardForPrint/context';

// function usePrevious(value) {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// }

const useGetImage = (imageId) => {
  const printProvidedValue = usePrint();
  const { data, isFetching } = useQuery(
    ['images', { imageId: imageId, isPrint: Boolean(printProvidedValue) }],
    async () => {
      updatePrintStatus(imageId, 'loadingStarted', true);
      return (
        await axios.get(`/images/${imageId}`, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 20000,
        })
      ).data;
    },
    {
      // enabled: !!imageId,
      enabled: !!imageId,
      refetchOnMount: false,
      onSettled: () => {
        updatePrintStatus(imageId, 'loadingFinished', true);
      },
    }
  );

  const updatePrintStatus = (imageId, propName, value) => {
    if (!printProvidedValue) {
      return;
    }
    const { setPrintImagesStatusArr } = printProvidedValue;

    setPrintImagesStatusArr((prevState) => {
      let imageStatusArray = [...prevState];
      const foundIndex = imageStatusArray.findIndex((imageStatusObj) => imageStatusObj.imageId === imageId);
      if (foundIndex === -1) {
        return imageStatusArray; // image not found in print images array
      }
      imageStatusArray[foundIndex] = {
        ...imageStatusArray[foundIndex],
        [propName]: value,
      };
      return imageStatusArray;
    });
  };

  return {
    image: data,
    isLoading: isFetching,
  };
};

export default useGetImage;
